<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @submit="handleSearch" :autoFormCreate="(form) => { this.searchForm = form }">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="搜索用户" fieldDecoratorId="uid">
              <a-input placeholder="ID/昵称" />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" htmlType='submit'>查询</a-button>
              <a-divider type="vertical" />
              <!-- <a-button style="margin-left: 8px" @click="handleExport">导出</a-button> -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <s-table ref="table" size="default" :columns="columns" :data="loadData">

      <template slot="is_abnormal" slot-scope="text, record">
        <span v-if="record.is_abnormal == 1">是</span>
        <span v-else>否</span>
      </template>
      <template slot="action" slot-scope="text, record">
        <a-popconfirm title="确定要修改吗？" @confirm="setAbnormal(record.id)">
          <a v-if="record.is_abnormal">取消异常</a>
          <a v-else>设为异常</a>
        </a-popconfirm>
        <a-divider type="vertical" />
        <a @click="gotoDetail(record)">兑换记录</a>
        <a-divider type="vertical" />
        <a @click="gotoGameCoinDetail(record)">游戏币记录</a>
      </template>
      <!-- <template slot="avatar" slot-scope="text">
        <span class="avatar"><img :src="text"></span>
      </template> -->
    </s-table>
  </a-card>
</template>
<script>

import STable from '@/components/table/'
import AInput from 'ant-design-vue/es/input/Input'

import { getUserList, setUserAbnormal } from '@/api/user'
import { encodeJsonToQuery } from '@/utils/util'
import { ACCESS_TOKEN } from "@/store/mutation-types"

export default {
  name: "UserList",
  components: {
    AInput,
    STable
  },
  data() {
    return {
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      form: null,
      mdl: {},
      // 查询参数
      searchForm: null,
      queryParam: {},
      // 表头
      columns: [
        // {
        //   title: '头像',
        //   dataIndex: 'avatar',
        //   scopedSlots: { customRender: 'avatar' },
        // },
        {
          title: '用户ID',
          dataIndex: 'uid'
        },
        {
          title: '昵称',
          dataIndex: 'nickname'
        },
        // {
        //   title: '所属门店',
        //   dataIndex: 'branch.name'
        // },
        {
          title: '娃娃个数',
          dataIndex: 'doll',
          needTotal: true,
        },
        {
          title: '老系统娃娃个数',
          dataIndex: 'old_doll',
          needTotal: true,
        },
        {
          title: '奥莱币',
          dataIndex: 'outlets_coin',
          needTotal: true,
        },
        {
          title: '游戏币',
          dataIndex: 'game_coins',
          needTotal: true,
        },
        {
          title: '兑换次数',
          dataIndex: 'exchange_times'
        },
        {
          title: '注册时间',
          dataIndex: 'created'
        },
        {
          title: "是否异常",
          dataIndex: "is_abnormal",
          scopedSlots: { customRender: 'is_abnormal' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: params => {
        return getUserList(Object.assign(params, this.queryParam)).then(res => res)
      },
    }
  },
  methods: {
    setAbnormal(id) {
      setUserAbnormal(id).then(res => {
        this.$message.success('修改成功')
        this.$refs.table.refresh()
      })
    },
    handleSearch(e) {
      e.preventDefault()
      this.queryParam = {
        uid: this.searchForm.getFieldValue('uid')
      }
      this.$refs.table.refresh()
    },
    gotoDetail(record) {
      let routerone = this.$router.resolve({ name: 'userRecord', params: { id: record.id } })
      window.open(routerone.href, '_blank');
    },
    gotoGameCoinDetail(record) {
      let routerone = this.$router.resolve({ name: 'gameCoin', params: { id: record.id } })
      window.open(routerone.href, '_blank');
    },
    handleExport() {
      const params = {
        uid: this.searchForm.getFieldValue('uid'),
        token: this.$ls.get(ACCESS_TOKEN)
      }
      window.open("/api/admin/users/excel" + encodeJsonToQuery(params))
    },
    handleEdit(record) {
      this.mdl = Object.assign({}, record)
      console.log(this.mdl)
      this.visible = true
    },
    handleOk() {
    },
    onChange(row) {
      this.selectedRowKeys = row.selectedRowKeys
      this.selectedRows = row.selectedRows
      console.log(this.$refs.table)
    }
  },
}
</script>
<style scoped>
.avatar {
  width: 48px;
  height: 48px;
}

.avatar>img {
  width: 48px;
  height: 48px;
  display: block;
  border-radius: 50%;
}
</style>

